import Icon from '../components/Icon.vue'

Icon.register({
  rss: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M128.1 416c0 35.4-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64 64 28.7 64 64zM303.7 463.2c0.5 9.1-6.8 16.8-16 16.8h-48.1c-8.4 0-15.5-6.5-16-14.9-7.3-112.1-96.9-201.5-208.8-208.8-8.4-0.5-14.9-7.6-14.9-16v-48.1c0-9.1 7.7-16.5 16.8-16 154.8 8.4 278.6 132.4 286.9 286.9zM448 463.5c0.3 9-7 16.5-16 16.5h-48.1c-8.6 0-15.6-6.8-16-15.5-7.8-191.1-161.3-344.6-352.5-352.5-8.6-0.4-15.5-7.4-15.5-16v-48.1c0-9 7.5-16.3 16.5-16 235 8.4 423.1 197.7 431.5 431.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/rss.js
// module id = 1848
// module chunks = 0